import { defineStore } from 'pinia'
import { ref } from 'vue'
export const useGlobalStore = defineStore('global', () => {
  const isSidebarSettingsOpen = ref(false)
  const isMenuNavigationOpen = ref(false)

  const toggleMenuNavigation = () => {
    isMenuNavigationOpen.value = !isMenuNavigationOpen.value
  }

  const toggleSidebarSettings = (value: boolean) => {
    isSidebarSettingsOpen.value = value
  }

  return {
    isSidebarSettingsOpen,
    isMenuNavigationOpen,
    toggleSidebarSettings,
    toggleMenuNavigation,
  }
})
